import { type UnitMappingByIssuerAndIdentifierPayload } from './useQueryUnitMappingByIdentifierAndIssuer';
import { type UnitMappingsSearchParams } from './useQueryUnitMappings';
import { type UnitsSearchParams } from './useQueryUnits';

export const queryKeysUnit = {
  base: () => 'unit' as const,
  getAll: (searchParams: UnitsSearchParams) =>
    [queryKeysUnit.base(), 'list', searchParams] as const,
  getAllMappings: (searchParams: UnitMappingsSearchParams) =>
    [queryKeysUnit.base(), 'list', 'mappings', searchParams] as const,
  getMappingByIssuerAndIdentifier: (
    unitMappingContext: UnitMappingByIssuerAndIdentifierPayload,
  ) =>
    [
      queryKeysUnit.base(),
      'mapping',
      'details',
      'byIssuerAndIdentifier',
      unitMappingContext,
    ] as const,
} as const;
